import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Stack } from "./Stack";
// eslint-disable-next-line react/display-name
export const VStack = forwardRef((props, ref) => {
    return (_jsx(Stack, Object.assign({}, props, { ref: ref, direction: "column", wrap: false, children: props.children })));
});
